import * as React from "react";
import {
    CalendarIcon,
    CrossIcon,
    DropdownIcon,
    MHWhiteLogo,
} from "../../assets/Icons";
import Typograpy from "../../components/ui/Typography";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Modals } from "../remittance/Modals";
import { receivingCountryData } from "../../utils";
import Button from "../../components/ui/Button";
import ErrorField from "../../components/ui/ErrorField";
import { getVendorCode } from "../../services/purposeCode";
import { Axios } from "../../services/axios";
import Toast from "../../components/ui/Toast";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/ui/Modal";

interface IFlywireProps {
    transactionMode?: string | undefined;
}
type ValuePiece = Date;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const Flywire: React.FC<IFlywireProps> = ({ transactionMode }) => {
    const [isModalOpen, setIsModalOpen] = React.useState<string>("");
    const [value, onChange] = React.useState<Value>(new Date());
    const [showCalendar, setShowCalendar] = React.useState<boolean>(false);
    const [destCurrency, setDestCurrency] = React.useState<string>("USD");
    const [showErrorField, setShowErrorField] = React.useState<Boolean>(false);
    const [refNumber, setRefNumber] = React.useState<string>("");
    const [vendorData, setVendorData] = React.useState<any>([]);
    const [amount, setAmount] = React.useState<any>();
    const [selectedVendor, setSelectedVendor] = React.useState<any>({});
    const [showVendorList, setShowVendorList] = React.useState<boolean>(false);
    const [searchQuery, setSearchQuery] = React.useState(""); // State for search input
    const [toastMessage, setToastMessage] = React.useState<any>();

    const navigate = useNavigate();

    const dropdownRef = React.useRef<HTMLDivElement>(null); // Create a ref for the dropdown div

    // Close dropdown if clicked outside
    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowVendorList(false); // Close the list if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside); // Add event listener on mount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside); // Cleanup on unmount
        };
    }, []);

    const handleVendorCodes = () => {
        getVendorCode()
            .then((res: any) => {
                setVendorData(res?.data);
            })
            .catch((error) => {
                console.error("ERROR", error);
            });
    };

    const date = new Date(value?.toString());

    const formattedDate = `${date.getFullYear()}-${String(
        date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const data = {
        modeOfTransaction: "Flywire",
        dateOfTransaction: formattedDate?.toString(),
        referenceNumber: refNumber,
        destinationCurrency: destCurrency,
        recipientReceive: Number(parseFloat(amount).toFixed(2)),
        vendorCode: selectedVendor?.vendorCode,
    };

    const sendFlywireDetails = async (data: any) => {
        const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
        const userToken = localStorage.getItem("userToken");
        return await Axios.post(
            `/remit/user/${currentUser.vendor_key}/offlineTransaction`,
            data,
            {
                headers: {
                    "Access-Control-Allow-Origin": "true",
                    "Content-Type": "application/json",
                    Authorization: `${userToken}`,
                    "X-Route-To": "remittance",
                },
            }
        )
            .then((res) => {
                setToastMessage(res?.data);
                setRefNumber("")
                setAmount("")
                setSearchQuery("")
                onChange(new Date())
            })
            .catch((res) => {
                setToastMessage(res?.data);
                setShowErrorField(true)
            });
    };

    const handleCloseToast = () => {
        setToastMessage(null);
    };

    return (
        <>
            {toastMessage && (
                <Toast
                    message={toastMessage?.message?.toUpperCase()}
                    type={toastMessage?.success === "true" ? "success" : "failure"}
                    onClose={handleCloseToast}
                />
            )}
            <div className="flex flex-col items-center bg-primary-1050 h-full md:min-w-[379px] pt-24 pb-[92px] fixed z-50">
                <div className="flex flex-col items-center w-full">
                    <div
                        onClick={() => {
                            navigate("/home")
                        }}
                        className="pb-[73px] pl-8 flex w-full  cursor-pointer"
                    >
                        <MHWhiteLogo />
                    </div>
                    {transactionMode && transactionMode !== "flywire"&& (
                        <div className="-mt-10 py-4 px-6 text-white text-[20px] font-bold rounded-[100px] bg-white bg-opacity-20 w-[233px] flex  justify-center items-center">
                            {transactionMode === "flywire"
                                ? ""
                                : transactionMode === "offline"
                                    ? "Offline Transactions"
                                    : transactionMode === "travel"
                                        ? "Travel Card"
                                        : ""}
                        </div>
                    )}
                    <div className="-mt-10 py-4 text-white text-[20px] w-[320px] flex flex-col justify-center items-center">
                        <p className="w-full">K2 (by moneyHOP) partners with Flywire to offer a seamless international education payments experience on a single platform.</p> 
                        <p className="pt-10">Now you can generate your Flywire instruction letter and have it directly mapped to your K2 account for a smooth and hassle-free experience.</p>
                    </div>
                </div>
            </div>


            <div className="bg-[#f0f9ff] p-2 ml-[379px] flex items-center justify-end h-full relative">
                <CrossIcon onClick={() => {
                            setIsModalOpen("cancelReasons")
                        }} className="cursor-pointer m-4" />
                </div>

            <div className="bg-[#f0f9ff] p-20 py-2 ml-[379px] flex flex-col h-full relative">
                <div className="bg-[#fff] flex flex-col gap-6 p-8 rounded">
                    <h3 className="text-black font-bold text-3xl">Flywire letter</h3>
                    <div className="w-full justify-start items-start flex">
                        <button onClick={() => window.open("https://agents.flywire.com/services/Q7Y8YB/edu-payments", "_blank")} className="min-w-44 font-semibold rounded-lg p-4 px-6 bg-primary-1050 w-1/3 text-white hover:text-primary-1050 hover:border-primary-1050 hover:bg-white border-2 hover:ease-in hover:delay-150 hover:duration-150 ">
                            Generate Now
                        </button>
                    </div>

                </div>
            </div>

            <div className="bg-[#f0f9ff] p-20 py-2 ml-[379px] flex flex-col h-full">
                <div className="bg-[#fff] flex max-w-full overflow-hidden flex-col gap-6 p-8 rounded">
                    <div className="flex items-center w-full justify-between">
                        <div className="flex max-w-full flex-col gap-3">
                            <Typograpy
                                tagType="p"
                                text={"Flywire mapping"}
                                className="text-black font-bold text-3xl"
                            />
                            {/* <Typograpy
                                tagType="p"
                                text={"Please enter the amount you want to transfer"}
                                className="text-black font-normal text-lg"
                            /> */}
                        </div>

                    </div>
                    <div className="flex flex-col gap-2 items-start">
                        <Typograpy tagType="p" text="Date of Transaction" />
                        <div className="flex flex-col items-end gap-1">
                            <div className="flex flex-row gap-2 py-3 px-4 justify-center items-center w-full min-w-[798px]  bg-[#fff] border border-[#efefef] rounded-lg shadow-md">
                                <input
                                    placeholder="Choose your date"
                                    value={formattedDate?.toString()}
                                    className="flex items-center w-full p-1 outline-none"
                                />
                                <CalendarIcon
                                    onClick={() =>
                                        showCalendar === false
                                            ? setShowCalendar(true)
                                            : setShowCalendar(false)
                                    }
                                    className="cursor-pointer"
                                />
                            </div>
                            {showCalendar && (
                                <div className="absolute top-[20.5rem] mt-2 z-50">
                                    <Calendar
                                        onClickDay={(e) => {
                                            onChange(e);
                                            setShowCalendar(false);
                                        }}
                                        value={value}
                                        selectRange={false}
                                        // minDate={new Date()}
                                        defaultValue={new Date()}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex flex-col max-w-full gap-2 items-start">
                        <Typograpy tagType="p" text="Flywire Referance" />
                        <div className="py-3 px-4 justify-center  bg-[#fff] border border-[#efefef] rounded-lg shadow-md">
                            <input
                                placeholder="Reference Number"
                                pattern="^[a-zA-Z0-9]+$" // Pattern that allows only alphanumeric characters
                                onChange={(e) => {
                                    const inputValue = e.target.value.toUpperCase();
                                    const alphanumericValue = inputValue.replace(
                                        /[^a-zA-Z0-9]/g,
                                        ""
                                    ); // Remove non-alphanumeric characters
                                    setRefNumber(alphanumericValue); // Update state with filtered value
                                    if (alphanumericValue.length === 12) {
                                        setShowErrorField(false); // If length is exactly 12, no error
                                    } else {
                                        setShowErrorField(true); // If length is not 12, show error
                                    }
                                }}
                                value={refNumber}
                                className="flex items-center w-full min-w-[770px] p-1 outline-none"
                                autoCapitalize={"characters"}
                                maxLength={12}
                            />
                        </div>
                        {showErrorField === true && (
                            <ErrorField errorMessage="Please Enter Correct Flywire Referance Number" />
                        )}
                    </div>

                    <div className="flex flex-col gap-2 max-w-[730px] items-start">
                        <Typograpy tagType="p" text="They Recieve" />
                        <div className="flex flex-row py-3 px-4 justify-center  bg-[#fff] border min-w-[798px] border-[#efefef] rounded-lg shadow-md">
                            <input
                                type="number"
                                placeholder="Enter amount"
                                value={amount}
                                onChange={(e) => setAmount(e?.target?.value)}
                                className="flex items-center w-full p-1 outline-none border-r-[#DFDFDF]"
                            />
                            <div
                                onClick={() => setIsModalOpen("recieve")}
                                className="flex space-x-3 rounded-md cursor-pointer border-l border-[#dfdfdf] mr-3"
                            >
                                <img
                                    src={`/images/png/${destCurrency}.png`}
                                    alt="receiving-country-image"
                                    className="rounded-[200px] w-7 h-7 ml-3"
                                />
                                <span className="bg-white text-[19px] space-x-2 flex items-center">
                                    <span className="">{destCurrency}</span>
                                    <DropdownIcon />
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col max-w-full gap-2 items-start" ref={dropdownRef}>
                        <Typograpy tagType="p" text="Vendor Code" />
                        <div className="flex flex-row items-center gap-2 py-3 px-4 justify-center bg-[#fff] border border-[#efefef] rounded-lg shadow-md">
                            <input
                                placeholder="Enter Vendor Code"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)} // Allow typing and update searchQuery
                                onClick={() => {
                                    handleVendorCodes();
                                    showVendorList === true ? setShowVendorList(false) : setShowVendorList(true);
                                }}
                                className="flex items-center w-[748px] p-1 outline-none cursor-pointer"
                            />
                            <div
                                onClick={() => {
                                    handleVendorCodes();
                                    showVendorList === true ? setShowVendorList(false) : setShowVendorList(true);
                                }}
                                className="cursor-pointer"
                            >
                                <DropdownIcon />
                            </div>
                        </div>

                        {showVendorList && (
                            <div className="w-[800px] h-fit max-h-52 overflow-y-scroll absolute top-[50.3rem]">
                                {vendorData.length > 0 ? (
                                    vendorData
                                        .filter((option: any) => {
                                            const searchLower = searchQuery.toLowerCase();
                                            return (
                                                option.displayName?.toLowerCase().includes(searchLower) ||
                                                option.vendorCode?.toLowerCase().includes(searchLower)
                                            );
                                        })
                                        .map((option: any, index: any) => (
                                            <div
                                                className="bg-grey-600 text-white p-2 cursor-pointer border-b border-white-100 hover:bg-[#fff] hover:text-black-350"
                                                key={index}
                                                onClick={() => {
                                                    setSelectedVendor(option); // Set selected vendor
                                                    setSearchQuery(option.displayName || option.vendorCode); // Set searchQuery to selected vendor
                                                    setShowVendorList(false); // Close the list
                                                }}
                                            >
                                                {option.displayName ? option.displayName : option.vendorCode}
                                            </div>
                                        ))
                                ) : (
                                    <div className="p-2 bg-grey-600 text-white">No vendor found</div>
                                )}
                                {vendorData.filter((option: any) => {
                                    const searchLower = searchQuery.toLowerCase();
                                    return (
                                        option.displayName?.toLowerCase().includes(searchLower) ||
                                        option.vendorCode?.toLowerCase().includes(searchLower)
                                    );
                                }).length === 0 && (
                                        <div className="bg-grey-600 p-4 text-white">No vendor found</div>
                                    )}
                            </div>
                        )}
                    </div>

                    <div className="flex flex-row max-w-[800px] !items-end justify-end">
                        <Button
                            bgColor="bg-[#023496]"
                            className="rounded-lg py-4 px-12 flex justify-center items-center text-white text-lg font-medium"
                            onClickHandler={async (e: any) => {
                                try {
                                    const response = await sendFlywireDetails(data);
                                    console.log("Response:", response);
                                } catch (error) {
                                    console.error("Error:", error);
                                }
                            }}
                            disabled={
                                showErrorField || amount?.length < 1 || searchQuery === ""
                            }
                        >
                            Submit
                        </Button>
                    </div>
                </div>

                <Modals
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    destCurrency={destCurrency}
                    setDestCurrency={setDestCurrency}
                    receivingCountryModalData={receivingCountryData}
                />
                <Modal
                    header="Cancel Transaction"
                    headerClass={"text-white"}
                    modalClass="!p-0 rounded lg:overflow-hidden overflow-y-scroll max-h-[90%] lg:max-h-full"
                    visible={isModalOpen === "cancelReasons"}
                    closeHandler={() => setIsModalOpen("")}
                    closable={false}
                >
                    <div className="flex flex-col items-center px-5 py-10 space-y-6">
                        <span className="font-ssp text-[18px] ">
                            Are you sure you want to cancel the transaction?
                        </span>
                        <div className="flex justify-center w-full space-x-5">
                            <button
                                onClick={() => navigate("/home")}
                                className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                            >
                                Yes
                            </button>
                            <button
                                onClick={() => setIsModalOpen("")}
                                className="w-1/4 px-6 py-2 font-bold text-white transition-all rounded-full bg-primary hover:bg-primary-650 hover:scale-105 font-ssp"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default Flywire;
